// components/ToastLoader.tsx
'use client';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export default function ToastLoader() {

  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar
      closeOnClick={false}
      theme="light"
      toastStyle={{
        padding: '16px',
        background: 'none',
        boxShadow: 'none',
        color: '#000',
        border: 'none',
      }}
    />
  );
}
